import { Loader } from '@mantine/core';

export function SearchLoadingSpinner() {
	return <Loader ml={2} size="md" />;
}
